module.exports = __webpack_public_path__ + "img/factor_b_gray.23a44e6d.svg";